export const countries = [
  { name: "United States", code: "US", dial: "1" },
  { name: "United Kingdom", code: "GB", dial: "44" },
  { name: "Canada", code: "CA", dial: "1" },
  { name: "Australia", code: "AU", dial: "61" },
  { name: "India", code: "IN", dial: "91" },
  { name: "Germany", code: "DE", dial: "49" },
  { name: "France", code: "FR", dial: "33" },
  { name: "Italy", code: "IT", dial: "39" },
  { name: "Spain", code: "ES", dial: "34" },
  { name: "Brazil", code: "BR", dial: "55" },
  { name: "Mexico", code: "MX", dial: "52" },
  { name: "Japan", code: "JP", dial: "81" },
  { name: "China", code: "CN", dial: "86" },
  { name: "South Korea", code: "KR", dial: "82" },
  { name: "Russia", code: "RU", dial: "7" },
  { name: "Netherlands", code: "NL", dial: "31" },
  { name: "Belgium", code: "BE", dial: "32" },
  { name: "Switzerland", code: "CH", dial: "41" },
  { name: "Sweden", code: "SE", dial: "46" },
  { name: "Norway", code: "NO", dial: "47" },
  { name: "Denmark", code: "DK", dial: "45" },
  { name: "Finland", code: "FI", dial: "358" },
  { name: "Ireland", code: "IE", dial: "353" },
  { name: "Portugal", code: "PT", dial: "351" },
  { name: "Austria", code: "AT", dial: "43" },
  { name: "Poland", code: "PL", dial: "48" },
  { name: "Greece", code: "GR", dial: "30" },
  { name: "Turkey", code: "TR", dial: "90" },
  { name: "South Africa", code: "ZA", dial: "27" },
  { name: "Nigeria", code: "NG", dial: "234" },
  { name: "Egypt", code: "EG", dial: "20" },
  { name: "Kenya", code: "KE", dial: "254" },
  { name: "Ghana", code: "GH", dial: "233" },
  { name: "Saudi Arabia", code: "SA", dial: "966" },
  { name: "United Arab Emirates", code: "AE", dial: "971" },
  { name: "Qatar", code: "QA", dial: "974" },
  { name: "Kuwait", code: "KW", dial: "965" },
  { name: "Bahrain", code: "BH", dial: "973" },
  { name: "Oman", code: "OM", dial: "968" },
  { name: "Israel", code: "IL", dial: "972" },
  { name: "Pakistan", code: "PK", dial: "92" },
  { name: "Bangladesh", code: "BD", dial: "880" },
  { name: "Sri Lanka", code: "LK", dial: "94" },
  { name: "Nepal", code: "NP", dial: "977" },
  { name: "Thailand", code: "TH", dial: "66" },
  { name: "Vietnam", code: "VN", dial: "84" },
  { name: "Philippines", code: "PH", dial: "63" },
  { name: "Malaysia", code: "MY", dial: "60" },
  { name: "Singapore", code: "SG", dial: "65" },
  { name: "Indonesia", code: "ID", dial: "62" },
  { name: "New Zealand", code: "NZ", dial: "64" },
  { name: "Argentina", code: "AR", dial: "54" },
  { name: "Chile", code: "CL", dial: "56" },
  { name: "Colombia", code: "CO", dial: "57" },
  { name: "Peru", code: "PE", dial: "51" },
  { name: "Venezuela", code: "VE", dial: "58" },
  { name: "Ecuador", code: "EC", dial: "593" },
  { name: "Uruguay", code: "UY", dial: "598" },
  { name: "Czech Republic", code: "CZ", dial: "420" },
  { name: "Romania", code: "RO", dial: "40" },
  { name: "Hungary", code: "HU", dial: "36" },
  { name: "Bulgaria", code: "BG", dial: "359" },
  { name: "Croatia", code: "HR", dial: "385" },
  { name: "Slovakia", code: "SK", dial: "421" },
  { name: "Slovenia", code: "SI", dial: "386" },
  { name: "Serbia", code: "RS", dial: "381" },
  { name: "Ukraine", code: "UA", dial: "380" },
  { name: "Morocco", code: "MA", dial: "212" },
  { name: "Tunisia", code: "TN", dial: "216" },
  { name: "Algeria", code: "DZ", dial: "213" },
  { name: "Jordan", code: "JO", dial: "962" },
  { name: "Lebanon", code: "LB", dial: "961" },
  { name: "Iraq", code: "IQ", dial: "964" },
  { name: "Iran", code: "IR", dial: "98" },
  { name: "Afghanistan", code: "AF", dial: "93" },
  { name: "Myanmar", code: "MM", dial: "95" },
  { name: "Cambodia", code: "KH", dial: "855" },
  { name: "Laos", code: "LA", dial: "856" },
  { name: "Taiwan", code: "TW", dial: "886" },
  { name: "Hong Kong", code: "HK", dial: "852" },
  { name: "Macao", code: "MO", dial: "853" },
  { name: "Mongolia", code: "MN", dial: "976" },
  { name: "Luxembourg", code: "LU", dial: "352" },
  { name: "Malta", code: "MT", dial: "356" },
  { name: "Cyprus", code: "CY", dial: "357" },
  { name: "Iceland", code: "IS", dial: "354" },
  { name: "Estonia", code: "EE", dial: "372" },
  { name: "Latvia", code: "LV", dial: "371" },
  { name: "Lithuania", code: "LT", dial: "370" },
  { name: "Costa Rica", code: "CR", dial: "506" },
  { name: "Panama", code: "PA", dial: "507" },
  { name: "Jamaica", code: "JM", dial: "1876" },
  { name: "Trinidad and Tobago", code: "TT", dial: "1868" },
  { name: "Dominican Republic", code: "DO", dial: "1809" },
  { name: "Guatemala", code: "GT", dial: "502" },
  { name: "Honduras", code: "HN", dial: "504" },
  { name: "El Salvador", code: "SV", dial: "503" },
  { name: "Nicaragua", code: "NI", dial: "505" },
  { name: "Bolivia", code: "BO", dial: "591" },
  { name: "Paraguay", code: "PY", dial: "595" },
  { name: "Tanzania", code: "TZ", dial: "255" },
  { name: "Uganda", code: "UG", dial: "256" },
  { name: "Ethiopia", code: "ET", dial: "251" },
  { name: "Cameroon", code: "CM", dial: "237" },
  { name: "Senegal", code: "SN", dial: "221" },
  { name: "Libya", code: "LY", dial: "218" },
  { name: "Sudan", code: "SD", dial: "249" },
  { name: "Georgia", code: "GE", dial: "995" },
  { name: "Armenia", code: "AM", dial: "374" },
  { name: "Azerbaijan", code: "AZ", dial: "994" },
  { name: "Kazakhstan", code: "KZ", dial: "7" },
  { name: "Uzbekistan", code: "UZ", dial: "998" },
];

export const findCountryByCode = (code) =>
  countries.find(c => c.code === code) || countries[0];
